import { lightTheme } from '@themes/lightTheme';
import { yellowTheme } from '@themes/yellowTheme';
import { grayTheme } from '@themes/grayTheme';
import { darkTheme } from '@themes/darkTheme';

export const getTheme = activeTheme => {
  switch (activeTheme) {
    case 0:
      return lightTheme;
    case 1:
      return yellowTheme;
    case 2:
      return grayTheme;
    case 3:
      return darkTheme;
    default:
      return lightTheme;
  }
};
